import {PaymentCurrencyType} from "@irati/types"

export const DEFAULT_REWARD_POINTS_NAME = "Reward Points" as const

/**
 * predicate to check passed in value is a Perkbox 'flexi' currency like Treat Tokens or Reward Points
 */
export function isFlexiCurrency(currency: any): currency is PaymentCurrencyType {
  return isRewardCurrency(currency) || isPerksCurrency(currency)
}

/**
 * predicate to check passed in value is a Perkbox 'reward' currency known as Reward Points
 *
 * the BE actually has this stored as `EP`, but most clients still use `RP`;
 * this helper allows most calling code to not think about the difference
 */
export function isRewardCurrency(currency: any): currency is PaymentCurrencyType {
  const checkCurrencies = [PaymentCurrencyType.Rp, PaymentCurrencyType.Ep, PaymentCurrencyType.Blend]
  return checkCurrencies.includes(currency || "NOPE")
}

/**
 * predicate to check passed in value is a Perkbox 'perks' currency known as
 * Treat Tokens or FlexiPoints (not to be confused with the broader 'flexi'
 * currency term referring to any of Perkbox's 'virtual' currencies)
 */
export function isPerksCurrency(currency: any): currency is PaymentCurrencyType {
  return currency === PaymentCurrencyType.Tt
}

/**
 * predicate to determine if the flexiCurrency value being passed in is a valid
 * cent based value (does not consider currency, assuming that has already been
 * asserted elsewhere with `isFlexiCurrency`)
 *
 * flexi currencies should always be cents, but in same cases, e.g deals, the prices are not cents
 */
export function isValidFlexiCurrencyAmount(amount: number, {isCents = true}: {isCents?: boolean} = {}) {
  if (isCents) {
    return (
      amount === 0 ||
      (amount >= 100 && // must be a whole unit, i.e no cent values
        Math.floor(amount) === amount && // shows we have an integer
        amount % 100 === 0) // proves divisible to a single non-cent value
    )
  }
  return amount >= 0 && Math.floor(amount) === amount // shows we have an integer
}
